export default __webpack_public_path__ + "static/media/hörtest-avatar-05.434c6fc0.svg";